import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';
import type { OpdrachtgeverRij } from '@vip/shared';

/**
 * Aanvinken op welke opdrachten iemand zit. Gebruikt door de Admin op de
 * personenpagina en door de buddy in zijn eigen roster, zodat die twee dezelfde
 * lijst met dezelfde groepering tonen.
 *
 * Eén scrollvak met een vaste hoogte, en geen kaartje per regel: er staan er nu
 * al elf en dat groeit met elke nieuwe klant. Uitgeklapt duwt zo'n lijst de
 * knoppen eronder van het scherm, en dan is niet meer te zien dat er nog iets
 * op te slaan valt.
 *
 * De opdrachtgever staat als kopje boven zijn opdrachten: "Onderhoud Noord" zegt
 * pas iets met de klant ervoor. Het kopje scrollt gewoon mee; bleef het boven
 * staan, dan schoven de vinkjes eronder er zichtbaar doorheen.
 */
export function OpdrachtenKiezer({
  className,
  gekozen,
  onWissel,
  opdrachtgevers,
  idPrefix = 'opdracht',
}: {
  className?: string;
  gekozen: readonly string[];
  onWissel: (id: string, aan: boolean) => void;
  opdrachtgevers: readonly OpdrachtgeverRij[];
  idPrefix?: string;
}) {
  // Zonder één opdracht in de administratie is een leeg kader een raadsel;
  // dan liever de zin, met de knop om er een aan te maken eronder.
  if (opdrachtgevers.every((g) => g.opdrachten.length === 0)) {
    return (
      <p className={cn('text-sm text-muted-foreground', className)}>Er zijn nog geen opdrachten.</p>
    );
  }

  return (
    <div className={cn('max-h-64 overflow-y-auto rounded-md border p-1', className)}>
      {opdrachtgevers.map((g) => (
        <div className="mt-2 first:mt-0" key={g.id}>
          <div className="px-2 py-1 text-xs font-medium text-muted-foreground">{g.naam}</div>
          {g.opdrachten.map((o) => (
            <label
              className="flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 hover:bg-muted/50"
              htmlFor={`${idPrefix}-${o.id}`}
              key={o.id}
            >
              <Checkbox
                checked={gekozen.includes(o.id)}
                id={`${idPrefix}-${o.id}`}
                onCheckedChange={(aan) => onWissel(o.id, aan === true)}
              />
              <span>{o.naam}</span>
            </label>
          ))}
        </div>
      ))}
    </div>
  );
}
